import Container from "client/common/components/layouts/Container";

import { HeroVisualBlock as HeroVisualBlockType } from "../../types";
import Block from "../Block";
import MarkdownText from "../helper/MarkdownText";

import styles from "../../styles/HeroVisualBlock.module.less";

type HeroVisualBlockProps = {
  className: string;
  block: HeroVisualBlockType;
};

const HeroVisualBlock = ({ block, className }: HeroVisualBlockProps) => {
  return (
    <div className={className}>
      {block.visual && (
        <div className={styles.visual}>
          <Block block={block.visual} />
        </div>
      )}
      <div className={styles.body}>
        <Container>
          <div className={styles.content}>
            {(block.title || block.subtitle) && (
              <div className={styles.headers}>
                {block.title && (
                  <p className={styles.header}>
                    <MarkdownText value={block.title} />
                  </p>
                )}
                {block.subtitle && (
                  <h3 className={styles.subheader}>
                    <MarkdownText value={block.subtitle} />
                  </h3>
                )}
              </div>
            )}
            {block.content && <Block block={block.content} />}
          </div>
        </Container>
      </div>
    </div>
  );
};

export default HeroVisualBlock;
